import React from 'react';
import { Link } from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddCategoryButton = ({ classes, record }) => (
  <Button
    className={classes.button}
    variant="contained"
    component={Link}
    to={`/quiz_question_categories/create?quiz=${record['@id']}`}
    label="Add a category"
    title="Add a category"
  >
    <AddBoxIcon />
  </Button>
);

export default withStyles(styles)(AddCategoryButton);
